import ReactPixel from "react-facebook-pixel";

const PIXEL_ID = "1594155218667235";

export const initMetaPixel = () => {
  ReactPixel.init(PIXEL_ID, undefined, {
    autoConfig: true,
    debug: false,
  });
  ReactPixel.pageView();
};

export const trackPageView = () => {
  ReactPixel.pageView();
};

export const trackEvent = (eventName: string, data?: object) => {
  ReactPixel.track(eventName, data);
};
